import { createContext, useContext, useMemo, useState } from "react";
import { playSpray } from "@/lib/sound";
import { toast } from "sonner";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const [justAdded, setJustAdded] = useState(false);

  const addItem = (product) => {
    playSpray(0.35); // flish suave al añadir a la cesta
    setItems((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) return prev.map((i) => (i.id === product.id ? { ...i, quantity: i.quantity + 1 } : i));
      return [...prev, { ...product, quantity: 1 }];
    });

    setJustAdded(true);
    setTimeout(() => setJustAdded(false), 1200);

    toast.custom((t) => (
      <div className="bg-black/90 border border-gold/40 text-white px-5 py-4 flex items-center gap-4 shadow-2xl backdrop-blur-xl">
        <span className="text-gold text-lg">✦</span>
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold">Añadido a la cesta</p>
          <p className="text-xs font-serif-lux text-white mt-0.5">{product.name}</p>
        </div>
      </div>
    ), { duration: 2500 });

    setCartOpen(true);
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  const setQty = (id, qty) => {
    if (qty < 1) return removeItem(id);
    setItems((prev) => prev.map((i) => (i.id === id ? { ...i, quantity: qty } : i)));
  };

  const clear = () => setItems([]);

  const total = useMemo(() => items.reduce((s, i) => s + i.price * i.quantity, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, setQty, clear, total, count, cartOpen, setCartOpen, checkoutOpen, setCheckoutOpen, justAdded }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
